module.exports = __webpack_public_path__ + "img/Exchange.69e6e6d6.svg";